import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import CkEditor from "../../../Components/CkEditor";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetBrandState, getBrand } from "../../../store/brand/action";
import { getProductCategory as onGetProductCategorys, addNewProductCategory as onAddNewProductCategory, updateProductCategory as onUpdateProductCategory, deleteProductCategory as onDeleteProductCategory, getProductCategoryLoading } from "../../../store/productCategory/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const ProductCategory = () => {
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, branches, branchLoading, positions, productCategories, isProductCategoryCreated, isProductCategorySuccess, loading, error, brands, brandLoading, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    productCategories: state.ProductCategory.productCategories,
    isProductCategoryCreated: state.ProductCategory.isProductCategoryCreated,
    isProductCategorySuccess: state.ProductCategory.isProductCategorySuccess,
    loading: state.ProductCategory.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    error: state.ProductCategory.error,
    positions: state.Position.positions,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
  }));

  const [productCategoryList, setProductCategoryList] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [brandList, setBrandList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const statusVisibilityData = [
    {
      options: [
        { label: "Visible", value: "Visible" },
        { label: "Hidden", value: "Hidden" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [productCategoryFiles, setProductCategoryFiles] = useState([]);
  const [logo, setLogo] = useState(defaultImg);
  const [printDoc, setPrintDoc] = useState([]);

  useEffect(() => {
    if (branchSelected) {
      dispatch(onGetProductCategorys());
      handleGetBrand(companySelected.value);
    }
  }, [branchSelected]);

  const onClickDelete = (productCategory) => {
    setProductCategory(productCategory);
    setDeleteModal(true);
  };

  const handleGetBrand = (companyId) => {
    dispatch(resetBrandState());
    dispatch(getBrand({ companyId: companyId }));
  };

  const handleDeleteProductCategory = () => {
    if (productCategory) {
      dispatch(onDeleteProductCategory(productCategory));
      setDeleteModal(false);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = productCategoryFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setProductCategoryFiles(newState);
    } else {
      const index = productCategoryFiles.findIndex((fl) => fl.filename === file.filename);

      setProductCategoryFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    if (!isEmpty(productCategoryList)) {
      let arr = [];
      productCategoryList.forEach((product) => {
        arr.push({ value: product.id, label: product.name });
      });
    }
  }, [productCategoryList]);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(productCategories)) {
      let filteredProductCategorys = productCategories;
      if (activeTypeTab !== "all") {
        filteredProductCategorys = productCategories.filter((productCategory) => {
          return productCategory.product_category_status && productCategory.product_category_status.name === activeTypeTab;
        });
      }
      setProductCategoryList(filteredProductCategorys.map((el) => ({ ...el, isChecked: false })));
    }
  }, [productCategories]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "product_category_branch",
        label: "Project",
        isSelected: true,
        data: [],
      },
      {
        id: "product_tag_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (productCategoryList.length > 0) {
      productCategoryList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "brand_client") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [productCategoryList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredProductCategorys = productCategories;
      if (type !== "all") {
        filteredProductCategorys = productCategories.filter((productCategory) => {
          return productCategory.product_category_status && productCategory.product_category_status.name === type;
        });
      }
      setProductCategoryList(filteredProductCategorys);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  // useEffect(() => {
  //   if (!isEmpty(productCategories)) {
  //     setProductCategoryList(productCategories);
  //   }
  // }, [productCategories]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(productCategories)) {
      var data = [];
      var opt = [];
      productCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setParentList(data);
    }
  }, [productCategories]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    var data = [];
    var opt = [];
    brands.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (brands.length > 0) {
      setBrandList(data);
    }
  }, [brands]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProductCategory(null);
      setProductCategoryFiles([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleProductCategoryClick = useCallback(
    (arg) => {
      const productCategory = arg;
      let files = [];
      for (const f of productCategory.product_category_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setProductCategoryFiles(files);
      setProductCategory({
        id: productCategory.id,
        name: productCategory.name,
        image: productCategory.image,
        code: productCategory.code,
        description: productCategory.description,
        description_price: productCategory.description_price,
        client: {
          label: productCategory.product_category_client.name,
          value: productCategory.product_category_client.id,
        },
        company: {
          label: productCategory.product_category_company.name,
          value: productCategory.product_category_company.id,
        },
        visibility: productCategory.visibility && {
          label: productCategory.visibility,
          value: productCategory.visibility,
        },
        branch: productCategory.product_category_branch && {
          label: productCategory.product_category_branch.name,
          value: productCategory.product_category_branch.id,
        },
        brand: productCategory.product_category_brand && {
          label: productCategory.product_category_brand.name,
          value: productCategory.product_category_brand.id,
        },
        status: productCategory.product_category_status && {
          label: productCategory.product_category_status.name,
          value: productCategory.product_category_status.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (productCategory && productCategory.client) || clientSelected,
      company: (productCategory && productCategory.company) || companySelected,
      name: (productCategory && productCategory.name) ?? "",
      image: (productCategory && productCategory.image) ?? "",
      code: (productCategory && productCategory.code) ?? "",
      status: (productCategory && productCategory.status) ?? "",
      description: (productCategory && productCategory.description) ?? "",
      description_price: (productCategory && productCategory.description_price) ?? "",
      branch: (productCategory && productCategory.branch) ?? "",
      brand: (productCategory && productCategory.brand) ?? "",
      parent: productCategory && productCategory.parent,
      visibility: (productCategory && productCategory.visibility) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: (values) => {
      dispatch(getProductCategoryLoading());
      if (isEdit) {
        const updateProductCategory = {
          id: productCategory ? productCategory.id : 0,
          name: values.name,
          image: values.image,
          code: values.code,
          statusId: values.status.value,
          description: values.description,
          description_price: values.description_price,
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          brandId: values.brand.value,
          parentId: values.parent ? values.parent.value : null,
          visibility: values.visibility && values.visibility.value,
          files: productCategoryFiles.length > 0 ? productCategoryFiles : [],
        };
        dispatch(onUpdateProductCategory(updateProductCategory));
        validation.resetForm();
      } else {
        const newProductCategory = {
          name: values.name,
          image: values.image,
          code: values.code,
          statusId: values.status.value,
          description: values.description,
          description_price: values.description_price,
          clientId: values.client.value,
          companyId: values.company.value,
          branchId: values.branch.value,
          brandId: values.brand.value,
          parentId: values.parent ? values.parent.value : null,
          visibility: values.visibility && values.visibility.value,
          files: productCategoryFiles.length > 0 ? productCategoryFiles : [],
        };
        dispatch(onAddNewProductCategory(newProductCategory));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteProductCategory(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = productCategoryList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setProductCategoryList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = productCategoryList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setProductCategoryList(updatedData);
                }}
              />
            </div>
          );
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateProductCategory") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  const productCategoryData = cellProps.row.original;
                  handleProductCategoryClick(productCategoryData);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteProductCategory") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const productCategoryData = cellProps.row.original;
                  onClickDelete(productCategoryData);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Produk",
        accessor: "name",
        filterable: true,
        Cell: (data) => {
          return (
            <>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm bg-light rounded p-1">{data.row.original.image && <img src={data.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${data.row.original.image}-w-100`} alt="" className="img-fluid d-block" style={{ height: "45px" }} />}</div>
                </div>
                <div className="flex-grow-1">
                  <p className="text-muted mb-0">{data.row.original.name}</p>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Project",
        accessor: "product_category_branch.name",
        filterable: true,
      },
      {
        Header: "Grup Usaha",
        accessor: "product_category_client.name",
        filterable: true,
      },
      {
        Header: "Perusahaan",
        accessor: "product_category_company.name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "product_category_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [productCategoryList, handleProductCategoryClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = productCategoryList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setProductCategoryList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => productCategoryList, [productCategoryList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleProductCategoryStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetProductCategorys(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setProductCategoryList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(onGetProductCategorys());
    handleGetBrand(companySelected?.value ?? "");
  };

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setProductCategoryFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  document.title = "Type Rumah | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={productCategoryList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteProductCategory} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Produk" pageTitle="Type Rumah" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createProductCategory") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setProductCategory("");
                setIsEdit(false);
                setCompanyList([]);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteProductCategory") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="productCategoryList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA TYPE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Type Rumah" : "Tambah Type Rumah"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-5">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("branch", "");
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="branch-field" className="form-label">
                              Cabang&nbsp;
                              {branchLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="branch"
                              value={validation.values.branch}
                              placeholder="Pilih Cabang/Proyek"
                              onChange={(e) => {
                                dispatch(setBranchSelect(e));
                                validation.setFieldValue("branch", e);
                              }}
                              options={branchList}
                            ></Select>
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="brand-field" className="form-label">
                              Brand&nbsp;
                              {brandLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="brand"
                              value={validation.values.brand}
                              placeholder="Select Brand"
                              onChange={(e) => {
                                validation.setFieldValue("brand", e);
                              }}
                              options={brandList}
                            ></Select>
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="brand" className="form-label">
                              Parent
                              {loading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="parent"
                              value={validation.values.parent}
                              placeholder="Enter Parent"
                              onChange={(e) => {
                                validation.setFieldValue("parent", e);
                              }}
                              options={parentList}
                              invalid={validation.touched.parent && validation.errors.parent ? true : false}
                            ></Select>
                            {validation.touched.parent && validation.errors.parent ? (
                              <p className="text-danger" type="invalid">
                                {validation.errors.parent}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder=" Type Rumah" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>
                          <div className="row">
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="type-field" className="form-label">
                                Status
                              </Label>
                              <Select
                                name="status"
                                value={validation.values.status}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  validation.setFieldValue("status", e);
                                }}
                                options={statusActiveData}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="visibility" className="form-label">
                                Visibility
                              </Label>
                              <Select
                                name="visibility"
                                placeholder="Pilih visibility"
                                value={validation.values.visibility}
                                onChange={(e) => {
                                  validation.setFieldValue("visibility", e);
                                }}
                                options={statusVisibilityData}
                              ></Select>
                              {validation.touched.visibility && validation.errors.visibility && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.visibility}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="image" className="form-label">
                              Gambar
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? defaultImg : `${api.MEDIA_URL}/media/${validation.values.image}-w-150`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("image", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="taskFiles" className="form-label me-3">
                              File Type Rumah
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {productCategoryFiles.map((productFile, i) => {
                            if (productFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={productFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${productFile.filename}-w-150`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>
                                    <div className="text-truncate">{productFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          handleDeleteFile(productFile);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                        <div className="col-lg-7">
                          <div className="mb-3">
                            <Label htmlFor="title-field" className="form-label">
                              Keterangan
                            </Label>

                            <CkEditor
                              data={validation.values.description}
                              onReady={(editor) => {
                                editor.editing.view.change((writer) => {
                                  writer.setStyle("height", "300px", editor.editing.view.document.getRoot());
                                });
                              }}
                              onChange={(value) => {
                                validation.setFieldValue("description", value);
                              }}
                            />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="title-field" className="form-label">
                              Keterangan Harga
                            </Label>
                            <CkEditor
                              data={validation.values.description_price}
                              onReady={(editor) => {
                                editor.editing.view.change((writer) => {
                                  writer.setStyle("height", "300px", editor.editing.view.document.getRoot());
                                });
                              }}
                              onChange={(value) => {
                                validation.setFieldValue("description_price", value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            setCompanyList([]);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Simpan" : "Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductCategory;
